var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"loading-indicator text-center"},[(_vm.isSpinnerVisible)?_c('b-spinner',{attrs:{"label":"Loading"}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }